import { Typography } from '@mui/material';
import { Section } from '../ui/Section';
import { LogoMarquee } from '../ui/LogoMarquee';
import { Partners, PartnerRelation } from '../../lib/social-proof';

interface LogoMarqueeSectionProps {
    tagline?: string;
    background?: 'transparent' | 'default' | 'paper' | 'gradient' | 'dark';
    relations?: PartnerRelation[];
    partnersOverride?: typeof Partners; // allow manual override if needed
    animate?: boolean;
    speed?: number;
}

export function LogoMarqueeSection({
    tagline = "Our partners, programmes, and collaborators",
    background = "transparent",
    relations,
    partnersOverride,
    animate,
    speed = 40
}: LogoMarqueeSectionProps) {

    let displayedPartners = partnersOverride || Partners;

    if (relations && relations.length > 0) {
        displayedPartners = displayedPartners.filter(p =>
            p.relation && p.relation.some(r => relations.includes(r))
        );
    }

    // Sort by order if present
    displayedPartners.sort((a, b) => (a.order || 999) - (b.order || 999));

    // Auto-disable animation if few items and not explicitly set
    const shouldAnimate = animate !== undefined
        ? animate
        : displayedPartners.length > 5;

    if (displayedPartners.length === 0) return null;

    return (
        <Section py={6} variant={background as any}>
            {tagline && (
                <Typography
                    variant="body2"
                    sx={{ textAlign: "center", color: "text.secondary", mb: 4 }}
                >
                    {tagline}
                </Typography>
            )}
            <LogoMarquee
                partners={displayedPartners}
                speed={speed}
                animate={shouldAnimate}
            />
        </Section>
    );
}
